<template>
	<el-container>
		<Header ref="header"></Header>
		<div class="product-issued-info" style="width: 960px;margin-left: auto;margin-right: auto;margin-bottom: 20px;position: relative;">
			<div class="info">
				<p class="wrapper-title">政策发布</p>
				<div style="position: absolute;left: 150px;top: 30px;">
					<el-tag v-if="formData.state==0" type="danger">待审</el-tag>
					<el-tag v-if="formData.state==2" type="info">已下线</el-tag>
					<el-tag v-if="formData.state==1">上线中</el-tag>
				</div>
				<div style="position: absolute;right: 30px;top:0px;">
					<button class="save" @click="handleSubmit">保存上线</button>
					<button class="save" style="background-color: red;" v-if="id!=undefined" @click="remove">下线</button>
					<button class="save" style="background-color: #f3f3f3;color: #333;" v-if="id!=undefined" @click="view">预览</button>
				</div>
				<table style="width: 100%;border-collapse: collapse;border-spacing: 0;margin-top:50px;">
					<tbody>
						<tr>
							<td style="width: 130px;">事项名称</td>
							<td><el-input type="text" v-model="formData.title" placeholder="填写政务事项名称" autocomplete="off"></el-input></td>
							<td style="width: 130px;">事项类别</td>
							<td style="width: 15%;">
								<el-select style="width: 100%" v-model="formData.category" disabled placeholder="请选择事项分类">
									<el-option value="鼓励扶持">鼓励扶持</el-option>
									<el-option value="资质审批">资质审批</el-option>
									<el-option value="事项许可">事项许可</el-option>
									<el-option value="规范经营">规范经营</el-option>
								</el-select>
							</td>
						</tr>
						<tr>
							<td>适用行业</td>
							<td colspan="3">
								<el-select v-model="formData.industry" multiple remote clearable filterable :remote-method="remoteMethod" :loading="loading" placeholder="请搜索后选择适应行业" style="width: 100%;">
									<el-option label="所有行业" value="所有行业"></el-option>
									<el-option v-for="item in options" :label="item.name" :value="item.name">
										<span style="float: left;width: 15vw;overflow: hidden;text-overflow: ellipsis;" :title="item.name">{{item.name}}</span>
										<span style="float: left;color: #8492a6;font-size: 13px;overflow: hidden;;max-width: 75vw;text-overflow: ellipsis;" :title="item.info">{{item.info}}</span> 
									</el-option>
								</el-select>
							</td>
						</tr>
						<tr>
							<td>企业规模</td>
							<td colspan="3">
								<el-select style="width: 100%" v-model="formData.level" multiple placeholder="请选择企业规模">
									<el-option label="不限类型" value="不限类型"></el-option>
									<el-option label="大型企业" value="大型企业"></el-option>
									<el-option label="中型企业" value="中型企业"></el-option>
									<el-option label="小型企业" value="小型企业"></el-option>
									<el-option label="微型企业" value="微型企业"></el-option>
								</el-select>
							</td>
						</tr>
						<tr>
							<td>企业类型</td>
							<td colspan="3">
								<el-select style="width: 100%" v-model="formData.companyLabel" multiple placeholder="请选择企业类型">
									<el-option label="不限类型" value="不限类型"></el-option>
									<el-option v-for="item in companyLabel" :label="item.name" :value="item.name"></el-option>
								</el-select>
							</td>
						</tr>
						<tr>
							<td rowspan="2">政策依据</td>
							<td rowspan="2">
								<el-input type="textarea" :rows="3" resize="none" v-model="formData.code" placeholder="填写文件名称及文件字号" autocomplete="off"></el-input>
							</td>
							<td>有效状态</td>
							<td><el-date-picker style="width: 100%" v-model="formData.write_date" type="date" value-format="yyyy-MM-dd" placeholder="截止日期"></el-date-picker></td>
						</tr>
						<tr>
							<td>原文上传</td>
							<td><el-select v-model="formData.upload" style="width: 100%"><el-option value="是">是</el-option><el-option value="否">否</el-option></el-select></td>
						</tr>
						<tr>
							<td>支持标准</td>
							<td colspan="3">
								<el-input v-model="formData.content1" type="textarea" :rows="5" :autosize="{minRows:3}" resize="none" placeholder="填写支持标准" autocomplete="off"></el-input>
							</td>
						</tr>
						<tr>
							<td>申办条件</td>
							<td colspan="3">
								<el-input v-model="formData.content2" type="textarea" :rows="10" :autosize="{minRows:10}" resize="none" placeholder="填写申办条件" autocomplete="off"></el-input>
							</td>
						</tr>
						<tr>
							<td>申办方式</td>
							<td colspan="3">
								<el-input v-model="formData.content3" type="textarea" :rows="10" :autosize="{minRows:10}" resize="none" placeholder="填写申办方式" autocomplete="off"></el-input>
							</td>
						</tr>
						<tr>
							<td colspan="4" style="border: 0px;border-right: 1px solid #333;">
								<table style="width: 100%;border-collapse: collapse;border-spacing: 0;">
									<tr>
										<td style="border-top: 0px;">在线联系</td>
										<td style="border-right: 0px;border-top: 0px;">
											<el-select @change="changeUser" style="width: 100%" v-model="formData.contact_uid" placeholder="请选择">
												<el-option v-for="(item, index) in contactList" :key="index" :label="item.name" :value="item.uid"></el-option>
											</el-select>
										</td>
										<td style="width: 130px;border-top: 0px;">申办网址</td>
										<td style="border-top: 0px;border-right: 0px;">
											<el-input type="text" v-model="formData.url" placeholder="请填写申办网址"autocomplete="off"></el-input>
										</td>
									</tr>
									<tr>
										<td style="width: 130px;">联系单位</td>
										<td><el-input v-model="formData.contact1" disabled type="text" placeholder="选择在线联系人后自动绑定" autocomplete="off"></el-input></td>
										<td>联系科室</td>
										<td style="border-right: 0px;">
											<el-input v-model="formData.contact2" disabled type="text" placeholder="选择在线联系人后自动绑定" autocomplete="off"></el-input>
										</td>
									</tr>
									<tr>
										<td>联系人员</td>
										<td>
											<el-input v-model="formData.contact3" disabled type="text" placeholder="选择在线联系人后自动绑定" autocomplete="off"></el-input>
										</td>
										<td>联系电话</td>
										<td style="border-right: 0px;">
											<el-input v-model="formData.contact4" disabled type="text" placeholder="选择在线联系人后自动绑定" autocomplete="off"></el-input>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</tbody>
				</table>
				<el-upload v-if="formData.upload=='是'" style="margin-top: 20px;" class="upload-demo" action='https://i-ddk.com/uploads.php' :on-remove="removeFile" :on-success="uploadFile" :file-list="formData.attachs">
					<el-button icon="el-icon-upload" type="primary">文件上传</el-button>
				</el-upload>
				<!-- <el-form ref="productForm" :model="formData" label-position="left" style="margin-top: 40px;" label-width="100px" :hide-required-asterisk="true"> -->
					<!-- <el-form-item label="事项分类" class="required">
						<el-select style="width: 100%" v-model="formData.category" placeholder="请选择事项分类">
							<el-option value="鼓励扶持">鼓励扶持</el-option>
							<el-option value="资质审批">资质审批</el-option>
							<el-option value="事项许可">事项许可</el-option>
							<el-option value="规范经营">规范经营</el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item label="政务事项" class="required">
						<el-input type="text" v-model="formData.title" placeholder="填写政务事项名称" autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="适应行业">
						<el-select v-model="formData.industry" multiple remote clearable filterable :remote-method="remoteMethod" :loading="loading" placeholder="请搜索后选择适应行业" style="width: 100%;">
							<el-option label="所有行业" value="所有行业"></el-option>
							<el-option v-for="item in options" :label="item.name" :value="item.name">
								<span style="float: left;width: 15vw;overflow: hidden;text-overflow: ellipsis;" :title="item.name">{{item.name}}</span>
								<span style="float: left;color: #8492a6;font-size: 13px;overflow: hidden;;max-width: 75vw;text-overflow: ellipsis;" :title="item.info">{{item.info}}</span> 
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="企业规模">
						<el-select style="width: 100%" v-model="formData.level" multiple placeholder="请选择事项分类">
							<el-option label="不限类型" value="不限类型"></el-option>
							<el-option label="大型企业" value="大型企业"></el-option>
							<el-option label="中型企业" value="中型企业"></el-option>
							<el-option label="小型企业" value="小型企业"></el-option>
							<el-option label="微型企业" value="微型企业"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="企业类型">
						<el-select style="width: 100%" v-model="formData.companyLabel" multiple placeholder="请选择事项分类">
							<el-option label="不限类型" value="不限类型"></el-option>
							<el-option v-for="item in companyLabel" :label="item.name" :value="item.name"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="有效期限">
						<el-date-picker style="width: 100%" v-model="formData.write_date" type="date" value-format="yyyy-MM-dd" placeholder="有截止日期的请填写"></el-date-picker>
					</el-form-item>
					<el-form-item label="申办网址">
						<el-input type="text" v-model="formData.url" placeholder="请填写申办网址"autocomplete="off"></el-input>
					</el-form-item>
					<el-form-item label="在线联系" class="required" prop="contact">
						<el-select style="width: 100%" v-model="formData.contact_uid" placeholder="请选择">
							<el-option v-for="(item, index) in contactList" :key="index" :label="item.name" :value="item.uid"></el-option>
						</el-select>
					</el-form-item> -->
				<!-- 	<el-form-item label="上传附件" class="required">
						<el-upload class="upload-demo" action='http://i-ddk.com/uploads.php' :on-remove="removeFile" :on-success="uploadFile" :file-list="formData.attachs">
							<el-button icon="el-icon-upload" type="primary">点击上传</el-button>
						</el-upload>
					</el-form-item>
				</el-form>-->
			</div> 
			<!-- <div class="divide-line"></div>
			<div class="desc">
				<p class="wrapper-title">详细描述 （ 内容格式请使用宋体18号，行间距使用2.5 ）</p>
				<RichTextEditor v-model="formData.content" />
			</div> -->
		</div>
	</el-container>
</template>

<script>
import Header from '@/components/Header.vue'
import RichTextEditor from '@/components/RichTextEditor.vue'
import address from "@/utils/address.json";
import {Api} from "../../utils/axios.js"
export default {
components: { RichTextEditor, Header},
data: () => ({
	id:'',
    formData: {
		image: '',
		title: '',
		code:'',
		category: '鼓励扶持',
		industry: [],
		write_date:'',
		level:[],
		url: '',
		content: '',
		attachs:[],
		companyLabel:[],
		contact_uid:'',
		upload:'否',
		content1:'',
		content2:'',
		content3:'',
		contact1:'',
		contact2:'',
		contact3:'',
		contact4:''
    },
    contactType: [],
    contactList: [{uid:'fdsdfsdfsdfsf',name:'罗帅'}],
	productIndustry: [],
	companyLabel:[],
	loading:false,
	options:[],
	industry:[],
	needRefresh:false,
	state:1,
	userinfo:JSON.parse(sessionStorage.getItem("USERINFO"))
  }),
  mounted() {
  	  window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
  },
  created(){
		this.addressData = address
		Api('data/contact',{}).then((res) => {
			if(res.code==200){
				this.contactList = res.result.contact
			}else{
				this.$message.error(res.msg)
			}
		})
		Api('data/companyLabel',{}).then((res) => {
			if(res.code==200){
				this.companyLabel = res.result
			}else{
				this.$message.error(res.msg)
			}
		})
		Api('product2/industryAll',{}).then((res) => {
			if(res.code==200){
				this.productIndustry = res.result
			}else{
				this.$message.error(res.msg)
			}
		  })
		  this.id = this.$route.query.id
		  if(this.id!=undefined){
			  this.loadData()
		  }
  },
  methods: {
	  beforeunloadHandler (e) {
	  	if(this.needRefresh){
	  		window.parent.opener.location.reload()
	  	}
	  },
    handleAvatarSuccess(res) {
      this.formData.image = res.file_path
      console.log(this.formData.image)
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleSubmit(offline) {
		let params = this.formData
		params.root = 1
		var user = JSON.parse(sessionStorage.getItem("USERINFO"))
		params.source_from = user.company.name
		if(offline==true){
			params.state = 2
		}else{
			params.state = 0
		}
		Api('service/save',params).then((res) => {
			if(res.code==200){
				this.needRefresh = true
				this.$message({message: '保存成功!',type: 'success',duration:1000,onClose:function(){window.close();}});
			}else{
				this.$message.error(res.msg)
			}
		})
    },
	view(){
		let routeData = this.$router.resolve({ path: '../govDetail',query:{id:this.id}});
		window.open(routeData.href, '_blank');
	},
	remove(){
		/* this.$confirm('数据删除后不可恢复, 是否继续删除?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'
		}).then(() => {
			Api('service/remove',{id:this.id}).then((res) => {
				if(res.code==200){
					this.needRefresh = true
					window.close()
				}else{
					this.$message.error(res.msg)
				}
			})
		}).catch((err)=>{}); */
		this.handleSubmit(true)
	},
	loadData(){
		Api('service/detail',{id:this.id}).then((res) => {
			console.log(res)
			if(res.code==200){
				this.formData = res.result
				this.state = res.result.state
				/* if(this.formData.attachs=="null"||this.formData.attachs==null||this.formData.attachs==""){
					this.formData.attachs = []
				}else{
					this.formData.attachs = JSON.parse(this.formData.attachs)
				} */
				this.formData.level = JSON.parse(this.formData.level)
				this.formData.companyLabel = JSON.parse(this.formData.companyLabel)
			}else{
				this.$message.error(res.msg)
			}
		})
	},
	remoteMethod(query){
		if(query!==''){
			this.loading = true
			this.options = this.productIndustry.filter(item=>{
				return item.name.indexOf(query) > -1 || (item.info!=null &&item.info.indexOf(query) > -1)
			})
			this.loading = false
		}else{
			this.options = []
		}
	},
	uploadFile(file){
		this.formData.attachs.push(file)
	},
	removeFile(file){
		console.log(file)
		for(var i=0;i<this.formData.attachs.length;i++){
			if(this.formData.attachs[i].file_path == file.file_path){
				this.formData.attachs.splice(i,1);
			}
		}
	},
	changeUser(){
		console.log(this.contactList)
		this.formData.contact1 = this.userinfo.company.name
		var self = this
		this.contactList.forEach(function(item){
			if(item.uid == self.formData.contact_uid){
				self.formData.contact2 = item.department
				self.formData.contact3 = item.name
				self.formData.contact4 = item.tel
			}
		})
	}
  }
}
</script>
<style>
	td{border: 1px solid #555;padding: 0px;text-align: center;font-size: 14px;}
	td .el-input__inner{border: 0px;}
	td .el-textarea__inner{border: 0px;}
	.el-date-picker td{border-width: 0px;}
</style>
<style scoped>
.product-issued-info {
  padding: 30px;
  border-radius: 10px;
  background-color: #fff;
  margin-top: 90px;
  overflow: hidden;
}
.header-tip {
  font-size: 14px;
  font-family: PingFang;
  font-weight: 400;
  color: #4a73ff;
}
.wrapper-title {
  margin-bottom: 20px;
  padding: 0 15px;
  font-size: 20px;
  font-family: PingFang;
  font-weight: bold;
  color: #222222;
  background-image: linear-gradient(to right, #4a73ff 4px, transparent 4px);
}
.avatar-uploader-icon {
  font-size: 60px;
  font-weight: lighter;
  color: #efefef;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  background-color: #f9f9f9;
}
.avatar {
  width: 100px;
  height: 100px;
}
.upload-tip {
  font-size: 14px;
  font-family: PingFang;
  font-weight: bold;
  color: #b1b1b1;
}
.divide-line {
  margin-top: 30px;
  margin-bottom: 30px;
  height: 1px;
  background: #efefef;
}
.save {
  width: 120px;
  height: 40px;
  background: #4a73ff;
  border-radius: 6px;
  border: none;
  font-size: 14px;
  font-family: PingFang;
  font-weight: bold;
  color: #ffffff;
  margin-top: 20px;
  float: right;
  text-align: center;
  margin-left: 20px;
  cursor: pointer;
}
.el-form-item__label{
  font-size: 14px;
  font-family: PingFang;
  font-weight: bold;
  color: #222222;
}
.avatar-uploader .el-upload {
  border-radius: 50%;
  cursor: pointer;
}
.el-input__inner {
  height: 34px;
  background: #f9f9f9;
  border: 1px solid #efefef;
  border-radius: 2px;
}
.required .el-form-item__label::after {
  content: '*';
  color: #db221a;
}
.el-checkbox__inner {
  border-radius: 50%;
}
.el-checkbox__inner::after {
  background-color: #00d773;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #00d773;
  background: #00d773;
}
.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
  background-color: #00d773;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #333333;
}
</style>
<style>
	.el-cascader-menu__wrap{height: 500px !important;}
</style>
